module.exports = __webpack_public_path__ + "static/media/zombies2.e766d292.jpg";